import React, { useContext, useState } from 'react';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';

import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';

import { bytesToMegabytes } from '../../../utils/feedback';

import GlobalContext from '../../../../../../../context/GlobalContext';

import {
  RootStyled,
  PreviewContainer,
  StyledModal,
  StyledModalHeader,
  StyledImageContainer,
  StyledModalImage,
} from './styles';

export default function AttachmentCard({
  file: { filename, size, url, extension },
}) {
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);
  const baseURL = process.env.REACT_APP_API;
  const protocol = subdomain.endsWith('-st') ? 'http' : 'https';

  const fileUrl = `${protocol}://${subdomain}.${baseURL}${url}`;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);

  const togglePreview = () => {
    if (['jpeg', 'jpg', 'png'].includes(extension)) {
      setImageModalOpen(true);
    } else {
      setPreviewOpen(!previewOpen);
    }
  };

  const handleCloseImageModal = () => {
    setImageModalOpen(false);
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    window.open(fileUrl);
  };

  const renderPreview = () => {
    if (!previewOpen) return null;
    const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;

    return (
      <>
        <Typography sx={{ my: 2 }} variant="h4" textAlign="center">
          O carregamento pode levar alguns segundos
        </Typography>
        <PreviewContainer>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <iframe
              src={googleViewerUrl}
              title={filename}
              width="100%"
              height="500px"
              style={{ border: 'none' }}
            />
          </Box>
        </PreviewContainer>
      </>
    );
  };

  return (
    <>
      <RootStyled elevation={0} onClick={togglePreview}>
        {extension === 'pdf' ? (
          <PictureAsPdfIcon sx={{ color: '#5ea8eb' }} />
        ) : (
          <ImageIcon sx={{ color: '#5ea8eb' }} />
        )}
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {filename}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {`${bytesToMegabytes(size)}MB`}
        </Typography>

        <IconButton
          onClick={handleDownload}
          size="small"
          sx={{ color: '#5ea8eb' }}
        >
          <DownloadIcon />
        </IconButton>
      </RootStyled>

      {renderPreview()}

      <Modal
        open={imageModalOpen}
        onClose={handleCloseImageModal}
        closeAfterTransition
      >
        <Fade in={imageModalOpen}>
          <StyledModal>
            <StyledModalHeader>
              <IconButton onClick={handleCloseImageModal} edge="end">
                <CloseIcon />
              </IconButton>
            </StyledModalHeader>
            <StyledImageContainer>
              <StyledModalImage src={fileUrl} alt={filename} />
            </StyledImageContainer>
            <Typography variant="body1" sx={{ mt: 2, fontWeight: 500 }}>
              {filename}
            </Typography>
          </StyledModal>
        </Fade>
      </Modal>
    </>
  );
}
